import { Region } from '@getpopsure/public-models';

import {
  ENGLISH_FRANCE_LOCALE_IDENTIFIER,
  ENGLISH_LOCALE_IDENTIFIER,
  ENGLISH_NETHERLANDS_LOCALE_IDENTIFIER,
  ENGLISH_SPAIN_LOCALE_IDENTIFIER,
} from './i18n';

export const lifeInByLocale: Record<string, string> = {
  [ENGLISH_LOCALE_IDENTIFIER]: 'life-in-germany',
  [ENGLISH_SPAIN_LOCALE_IDENTIFIER]: 'life-in-spain',
  [ENGLISH_NETHERLANDS_LOCALE_IDENTIFIER]: 'life-in-netherlands',
  [ENGLISH_FRANCE_LOCALE_IDENTIFIER]: 'life-in-france',
};

export const blogRegions: Region[] = ['de', 'es', 'nl', 'fr'];

export const BLOG_PATHNAME = 'blogV2';
